<template>
  <section>
    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex v-if="!Update_Details">Add Course SEO</v-flex>
          <v-flex v-else>Update Course SEO</v-flex>
          <v-btn icon @click="CloseDialog">
            <v-icon color="text--secondary">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex wrap style="padding: 10px;">
            <v-flex>
              <v-select
                v-if="!Update_Details"
                item-value="_id"
                item-text="name"
                return-object
                v-model="SelectedCourseDetail"
                :items="GetCourseDetailList"
                label="Select Course"
              >
                <template slot="selection" slot-scope="{ item }">{{ item.Course_Title }}</template>
                <template slot="item" slot-scope="{ item }">{{ item.Course_Title }}</template>
              </v-select>
              <v-flex
                v-else
                style="    font-size: 18px;
    font-weight: bold;padding: 10px;
"
              >Course Title : {{ SelectedCourseDetail.Course_Title }}</v-flex>
            </v-flex>
             <v-flex>
              <v-text-field label="Meta Title" v-model="Meta_Title"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Keywords" v-model="Meta_Keywords"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Description" v-model="Meta_Description"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Abstract" v-model="Meta_Abstract"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Author" v-model="Meta_Author"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Copyright" v-model="Meta_Copyright"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Distribution" v-model="Meta_Distribution"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Item Prop Name" v-model="Meta_Item_Prop_Name"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Item Prop Description" v-model="Meta_Item_Prop_Description"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Item Prop Image" v-model="Meta_Item_Prop_Image"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Type" v-model="Meta_Property_OG_Type"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG URL" v-model="Meta_Property_OG_URL"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG SiteName" v-model="Meta_Property_OG_SiteName"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Title" v-model="Meta_Property_OG_Title"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="Meta Property OG Description"
                v-model="Meta_Property_OG_Description"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Author" v-model="Meta_Property_OG_Author"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="Meta Property OG Image" v-model="Meta_Property_OG_Image"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="Meta Property Article Author"
                v-model="Meta_Property_Article_Author"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="Meta Property Article Publisher"
                v-model="Meta_Property_Article_Publisher"
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: right;">
            <v-btn color="success" v-if="!Update_Details" @click="SubmitCourseSEO">Add Course SEO</v-btn>
            <v-btn color="success" v-else @click="SubmitCourseSEO">Update Course SEO</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  props: ["dialog"],
  data() {
    return {
      Update_Details: false,
      SelectedCourseDetail: {},
      Meta_Title : "",
      Meta_Keywords: "",
      Meta_Description: "",
      Meta_Abstract: "",
      Meta_Author: "",
      Meta_Copyright: "",
      Meta_Distribution: "",
      Meta_Item_Prop_Name: "",
      Meta_Item_Prop_Description: "",
      Meta_Item_Prop_Image: "",
      Meta_Property_OG_Type: "",
      Meta_Property_OG_URL: "",
      Meta_Property_OG_SiteName: "",
      Meta_Property_OG_Title: "",
      Meta_Property_OG_Description: "",
      Meta_Property_OG_Author: "",
      Meta_Property_OG_Image: "",
      Meta_Property_Article_Author: "",
      Meta_Property_Article_Publisher: ""
    };
  },
  computed: {
    GetCourseDetailList() {
      return this.$store.getters.GetCourseDetailsList;
    }
  },
  methods: {
    CloseDialog() {
      this.ClearForm();
      this.$emit("close");
    },
    SetCurrentSEO(SEODetails) {
      this.GetCourseDetailsList()
        .then(response => {
          this.Update_Details = true;
          this.SelectedCourseDetail = this.GetCourseDetailList.find(
            x => x["_id"] == SEODetails["Course_Id"]
          );
          this.Meta_Title    = SEODetails['Meta_Title'];
          this.Meta_Keywords = SEODetails["Meta_Keywords"];
          this.Meta_Description = SEODetails["Meta_Description"];
          this.Meta_Abstract = SEODetails["Meta_Abstract"];
          this.Meta_Author = SEODetails["Meta_Author"];
          this.Meta_Copyright = SEODetails["Meta_Copyright"];
          this.Meta_Distribution = SEODetails["Meta_Distribution"];
          this.Meta_Item_Prop_Name = SEODetails["Meta_Item_Prop_Name"];
          this.Meta_Item_Prop_Description =
            SEODetails["Meta_Item_Prop_Description"];
          this.Meta_Item_Prop_Image = SEODetails["Meta_Item_Prop_Image"];
          this.Meta_Property_OG_Type = SEODetails["Meta_Property_OG_Type"];
          this.Meta_Property_OG_URL = SEODetails["Meta_Property_OG_URL"];
          this.Meta_Property_OG_SiteName =
            SEODetails["Meta_Property_OG_SiteName"];
          this.Meta_Property_OG_Title = SEODetails["Meta_Property_OG_Title"];
          this.Meta_Property_OG_Description =
            SEODetails["Meta_Property_OG_Description"];
          this.Meta_Property_OG_Author = SEODetails["Meta_Property_OG_Author"];
          this.Meta_Property_OG_Image = SEODetails["Meta_Property_OG_Image"];
          this.Meta_Property_Article_Author =
            SEODetails["Meta_Property_Article_Author"];
          this.Meta_Property_Article_Publisher =
            SEODetails["Meta_Property_Article_Publisher"];
        })
        .catch(error => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Error While Fetching Data",
            Color: "red",
            Close: false
          });
        });
    },
    SubmitCourseSEO() {
      let CourseSEO = {};
      CourseSEO["Course_Id"] = this.SelectedCourseDetail["_id"];
      CourseSEO["update"] = {};
      CourseSEO["update"]["Meta_Title"] = this.Meta_Title;
      CourseSEO["update"]["Meta_Keywords"] = this.Meta_Keywords;
      CourseSEO["update"]["Meta_Description"] = this.Meta_Description;
      CourseSEO["update"]["Meta_Abstract"] = this.Meta_Abstract;
      CourseSEO["update"]["Meta_Author"] = this.Meta_Author;
      CourseSEO["update"]["Meta_Copyright"] = this.Meta_Copyright;
      CourseSEO["update"]["Meta_Distribution"] = this.Meta_Distribution;
      CourseSEO["update"]["Meta_Item_Prop_Name"] = this.Meta_Item_Prop_Name;
      CourseSEO["update"][
        "Meta_Item_Prop_Description"
      ] = this.Meta_Item_Prop_Description;
      CourseSEO["update"]["Meta_Item_Prop_Image"] = this.Meta_Item_Prop_Image;
      CourseSEO["update"]["Meta_Property_OG_Type"] = this.Meta_Property_OG_Type;
      CourseSEO["update"]["Meta_Property_OG_URL"] = this.Meta_Property_OG_URL;
      CourseSEO["update"][
        "Meta_Property_OG_SiteName"
      ] = this.Meta_Property_OG_SiteName;
      CourseSEO["update"][
        "Meta_Property_OG_Title"
      ] = this.Meta_Property_OG_Title;
      CourseSEO["update"][
        "Meta_Property_OG_Description"
      ] = this.Meta_Property_OG_Description;
      CourseSEO["update"][
        "Meta_Property_OG_Author"
      ] = this.Meta_Property_OG_Author;
      CourseSEO["update"][
        "Meta_Property_OG_Image"
      ] = this.Meta_Property_OG_Image;
      CourseSEO["update"][
        "Meta_Property_Article_Author"
      ] = this.Meta_Property_Article_Author;
      CourseSEO["update"][
        "Meta_Property_Article_Publisher"
      ] = this.Meta_Property_Article_Publisher;

      
      this.$http
        .post(
          `${this.$store.getters.GetProductionUrl}/courseseo/addcourseseo`,
          CourseSEO
        )
        .then(response => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: `Successfully ${
              !this.Update_Details ? "Added Course" : "Updated Course"
            } SEO`,
            Color: "green",
            Close: false
          });
          !this.Update_Details
            ? this.$store.commit(
                "SetIndividualCourseSEO",
                response["data"]["response"][0]
              )
            : this.$store.commit(
                "UpdateIndividualCourseSEO",
                response["data"]["response"][0]
              );
          this.CloseDialog();
        })
        .catch(err => {
          this.$eventHub.$emit("SNACK_BAR", {
            Show: true,
            Text: "Failed To Add Course SEO",
            Color: "red",
            Close: false
          });
        });
    },
    ClearForm() {
      this.SelectedCourseDetail = {};
      this.Meta_Title = ""
      this.Meta_Keywords = "";
      this.Meta_Description = "";
      this.Meta_Abstract = "";
      this.Meta_Author = "";
      this.Meta_Copyright = "";
      this.Meta_Distribution = "";
      this.Meta_Item_Prop_Name = "";
      this.Meta_Item_Prop_Description = "";
      this.Meta_Item_Prop_Image = "";
      this.Meta_Property_OG_Type = "";
      this.Meta_Property_OG_URL = "";
      this.Meta_Property_OG_SiteName = "";
      this.Meta_Property_OG_Title = "";
      this.Meta_Property_OG_Description = "";
      this.Meta_Property_OG_Author = "";
      this.Meta_Property_OG_Image = "";
      this.Meta_Property_Article_Author = "";
      this.Meta_Property_Article_Publisher = "";
    },
    GetCourseDetailsList() {
      return new Promise((resolve, reject) => {
        
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`
          )
          .then(response => {
            this.$store.commit(
              "SetCourseDetailList",
              response["data"]["response"]
            );
            resolve(true);
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Error While Fetching Data",
              Color: "red",
              Close: false
            });
            reject(false);
          });
      });
    }
  }
};
</script>
<style scoped>
</style>